import { render, staticRenderFns } from "./RenderingEnvironments.vue?vue&type=template&id=c28b96ec&scoped=true&"
import script from "./RenderingEnvironments.vue?vue&type=script&lang=ts&"
export * from "./RenderingEnvironments.vue?vue&type=script&lang=ts&"
import style0 from "./RenderingEnvironments.vue?vue&type=style&index=0&id=c28b96ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28b96ec",
  null
  
)

export default component.exports